export enum UserAttributes {
    GivenName = 'given_name',
    FamilyName = 'family_name',
    Email = 'email',
    EmailVerified = 'email_verified',
    Notes = 'custom:Notes',
    Companies = 'custom:Companies',
    Resellers = 'custom:Resellers',
    Locations = 'custom:Locations',
    ProductEditRole = 'custom:ProductEditRole',
    UploaderRole = 'custom:UploaderRole',
    StoreEditRole = 'custom:StoreEditRole',
    UserEditRole = 'custom:UserEditRole',
    ResellerEditRole = 'custom:ResellerEditRole',
    PriceEditRole = 'custom:PriceEditRole',
}

export interface UserState {
    given_name: string;
    family_name: string;
    password?: string;
    email: string;
    'custom:Companies'?: string;
    'custom:Locations'?: string;
    'custom:Resellers'?: string;
    'custom:Notes': string;
    'custom:ProductEditRole': string;
    'custom:UploaderRole': string;
    'custom:StoreEditRole': string;
    'custom:UserEditRole': string;
    'custom:PriceEditRole': string;
}

export type DropdownData = { name: string; id: string }[];

export enum USER_TYPE {
    SUPER_ADMIN = 'super_admin',
    ADMIN = 'admin',
    LOCATION = 'location',
    COMPANIES = 'companies',
    INVALID = 'invalid',
}
